<template>
    <div class="main-content" id="panel">
         <!-- <Header /> -->
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                    <div class="row align-items-center py-4">
                        <div class="col-lg-6 col-7"><h2>Dashboard</h2></div>
                        <div class="text-right col-lg-6 col-5">
                            <span class="time">Local: <i class="fas fa-clock"></i> <time v-text="timeDate"></time> </span>
                            <span class="time">EST: <i class="fas fa-clock"></i> <time v-text="timeDateEST"></time> </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard bidside" >
            <div class="row">
                <div class="col-xl-12">
                    <div class="row">
                        <div class="col-xl-6 col-md-6 mb-3">
                            <div class="card maturityR">
                                <div class="card-header bg-transparent">
                                    <div class="row align-items-center">
                                        <div class="col red">
                                            <h3><i class="fas fa-bell"></i>Action Logs</h3>
                                        </div>
                                        <div class="text-right">
                                            <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i> Show All</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="acn-req" v-for="(log,i) in logs" :key="i">
                                        <div class="noti-icon"><i class="fas fa-bell"></i></div>
                                        <p>{{log.message}}</p>
                                        <!-- <p>Stephen S. Jackson bid has been <span class="border rounded-pill px-2 py-1 mx-2 border-danger text-danger">ECN Rejected</span></p> -->
                                    </div>
                                    
                                </div>
                            </div>    
                        </div>
                        <div class="col-xl-3 col-md-3 mb-3">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card maturityR">
                                        <div class="card-header bg-transparent">
                                            <div class="row align-items-center">
                                                <div class="col blue">
                                                    <h3><i class="fas fa-cloud-upload-alt"></i>Import Holdings</h3>
                                                </div>
                                                
                                                <div class="text-right">
                                                    <!-- <a class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i> More Info</a> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div v-if="!invUploadStatus" class="bid mb-3 imp-hld">
                                                <label  style="margin:5px"  @click="openImportInventoryModal()" class="custom-file-upload btn btn-primary"> HOLDINGS <i class="fas fa-cloud-upload-alt"></i></label><br>
                                                <label style="width:100%" @click="openInvAccHoldingModal()" class="custom-file-upload btn btn-primary"> INVENTORY ACCOUNT HOLDINGS <i class="fas fa-cloud-upload-alt"></i></label>
                                            </div>
                                            <div v-if="invUploadStatus == 'INPROGRESS'" class="bid mb-3 imp-hld">
                                                <label  style="margin:5px" class="custom-file-upload btn btn-primary"> IMPORTING <i class="fa fa-spinner fa-spin"></i></label><br> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card maturityR">
                                        <div class="card-header bg-transparent">
                                            <div class="row align-items-center">
                                                <div class="col violet">
                                                    <h3><i class="fas fa-exchange-alt"></i>Transaction Statistics</h3>
                                                </div>
                                                <div class="text-right">
                                                    <!-- <a class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i> More Info</a> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body tradesWid">
                                            <div class="bid mb-3">
                                                 <canvas id="transactionstatus"></canvas>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>    
                        </div>
                        <div class="col-xl-3 col-md-3 mb-3">
                            <div class="card maturityR">
                                <div class="card-header bg-transparent">
                                    <div class="row align-items-center">
                                        <div class="col black">
                                            <h3><i class="fas fa-coins"></i>Authorizations</h3>
                                        </div>
                                        <div class="text-right">
                                            <!-- <a class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i> More Info</a> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="bid Mb-3">
                                        <div class="auth">
                                            <span class="bid-count text-danger">{{pendingStatus.bidCount}}</span> BIDS 
                                            <span class="d-block"> in <span>{{pendingStatus.customerCount}}</span> Customers</span>
                                            <!-- <a><i class="fas fa-check"></i>Approve</a> -->
                                        </div>
                                    </div>
                                    <div class="card-header bg-transparent">
                                        <div class="row align-items-center">
                                            <div class="col green">
                                                <h3><i class="fas fa-coins"></i>Successful Bids</h3>
                                            </div>
                                            <div class="text-right">
                                                <!-- <a class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i> More Info</a> -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="auth">
                                        <span class="bid-count text-success">{{successStatus.bidCount}}</span> BIDS <br>
                                        <span class="d-block"> in <span>{{successStatus.customerCount}}</span> Customers</span> <br>
                                        <span style="color:#ffa300" class="bid-count">{{successStatus.broughtInCount}}</span> BROUGHT IN BIDS <br> 
                                        <span class="d-block"> in <span>{{successStatus.broughtInCustomerCount}}</span> Customers</span> <br>
                                        <span class="text-success"><i class="fas fa-thumbs-up"></i>Sold</span>
                                    </div>
                                </div>
                            </div>     
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ImportInventory v-if="importInventoryModal" @close="closeImportInventoryModal()" />
        <ImporInventoryAccount v-if="importInventoryAccModal" @close="closeImportInventoryModal()" />
    </div>
</template>
<script>
import moment from 'moment'
import moment_timezone from 'moment-timezone'
import config from "@/config";
import authService from "@/authService";
import ImportInventory from "@/components/ims/ims-inventory/ImsImportInventoryModal";
import ImporInventoryAccount  from "@/components/ims/ims-inventory/ImsImportInventoryAccountModal";

export default {
  name: "ba-dashboard",
   components: {
        ImporInventoryAccount,
        ImportInventory
  },
  data() {
    return {
      timeDate : "",
      timeDateEST : "",
      importInventoryModal : false,
      importInventoryAccModal : false,
      successStatus : {},
      pendingStatus : {},
      transactionsCount : {},
      transactionStatusChartOptions: {
        type: 'bar',
        data: {
          labels: [],
          datasets: [{
            label: '',
            data: [],
            backgroundColor: "#0084CC",
            barPercentage: 0.2,
            borderWidth: 1
          }]
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                userCallback: function(label) {
                  // when the floored value is the same as the value we have a whole number
                  if (Math.floor(label) === label) {
                      return label;
                  }

              },
              },
              scaleLabel: {
                display: true,
                labelString: ''
              },
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
                }

            },
            ],
            xAxes: [{
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              },
              scaleLabel: {
                display: true,
                labelString: ''
              },
               ticks: {
                    fontSize: 10
                }

            }, ]
          },
          legend: {
            display: false
          },
          plugins: {
            labels: {
              render: function () {
                return '';
              },
            }
          } 
        }
      },
      myChart : null,
      logs : [],
      invUploadStatus : localStorage.getItem("INVUPLOADSTATUS")

      
    };
  },
  methods: {
    navigateListPage(){
       window.location.href = "/bidaccumulator/actionlogs";
    },
    openImportInventoryModal(){
        this.importInventoryModal = true;
    }, 
    openInvAccHoldingModal(){
      this.importInventoryAccModal = true;
    }, 
    closeImportInventoryModal(){
      this.importInventoryModal = false;
      this.importInventoryAccModal = false;
      this.invUploadStatus = localStorage.getItem("INVUPLOADSTATUS");
    },   
    getPendingStats(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
            config.baseUrlBidSide +
            "/bidwanted/auth-stats?type=BID_RECEIVED",
            auth
        )
        .then(result => {
            this.pendingStatus = result.data;
            this.loading = false;
        }).catch(() => this.loading = false);
    },
    getSuccessStats(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
            config.baseUrlBidSide +
            "/bidwanted/success-stats?type=SUCCESS",
            auth
        )
        .then(result => {
            this.successStatus = result.data;
            this.loading = false;
        }).catch(() => this.loading = false);
    },
    getTransactionGraphData(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        let fromDate = this.moment(this.moment().format("MM-DD-YYYY")).utc().format("MM-DD-YYYY HH:mm:ss") 
        let toDate = this.moment(this.moment().format("MM-DD-YYYY")).add(1,'days').utc().format("MM-DD-YYYY HH:mm:ss") 
        this.$http
        .get(
            config.baseUrlBidSide +
            "/bidwanted/stats?type=SUCCESS&fromDate="+fromDate+"&toDate="+toDate,
            auth
        )
        .then(result => {
            this.transactionsCount = result.data;
            this.loading = false;
            this.transactionStatusChartOptions.data.labels = ["SUCCESS","BROUGHT IN","TOTAL"]
            this.transactionStatusChartOptions.data.datasets[0].data = [
                this.transactionsCount.successCount,
                this.transactionsCount.broughtInCount,
                this.transactionsCount.totalCount,
                ];
            // this.transactionStatusChartOptions.data.datasets[0].data = [10,20,30]

            this.transactionStatusChartOptions.data.datasets[0].backgroundColor = ["#56b58b", "#ea6f7c", "#7e698f","#E96875","#FF9E47","#56B68B"];
            if(this.myChart){
                this.myChart.destroy();
            }
            const ctx = document.getElementById("transactionstatus");
            this.myChart = new window.Chart(ctx, {
                type: this.transactionStatusChartOptions.type,
                data: this.transactionStatusChartOptions.data,
                options: this.transactionStatusChartOptions.options
            });
        }).catch(() => this.loading = false);
    },
    getLogs(){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide + "/bidwanted/status-list?offset=0&limit=10",
          auth
        )
        .then((result) => {
            this.logs = result.data;
            this.loading = false;

        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    
  },
  mounted() {
    setInterval(() => {
      this.timeDate =  moment().format('LT') + " | " + moment().format('dddd') + ", " + moment().format("DD MMM YYYY"); 
      this.timeDateEST =  moment_timezone().tz('America/New_York').format('LT') + " | " + moment_timezone().format('dddd') + ", " + moment_timezone().format("DD MMM YYYY");  
    }, 1000);
    this.getPendingStats();
    this.getSuccessStats();
    this.getTransactionGraphData();
    this.getLogs();
    this.$root.$on("INVUPLOADCOMPLETED", () => {
      this.invUploadStatus = null;
    });
  }
};
</script>